import React, { useMemo } from "react"
import Lightbox, { isImageFitCover, isImageSlide, useLightboxProps } from "yet-another-react-lightbox"
import "yet-another-react-lightbox/styles.css"
import { ASSET_TYPE } from "@/constants"
import styled from "styled-components"
import dynamic from "next/dynamic"

const Image = dynamic(() => import("@/components/common/Image"))
const Video = dynamic(() =>
	import("@/components/common/Video").then(
		(mod) => styled(mod)`
			pointer-events: none;

			iframe,
			video {
				pointer-events: auto;
			}

			figure {
				pointer-events: none;

				&:before {
					content: none;
				}
			}
		`,
	),
)

function formatToGalleryItem(item) {
	const type = item?.type || ASSET_TYPE.IMAGE

	return {
		src: type === ASSET_TYPE.IMAGE ? item?.url || item?.src || "" : item?.customData?.galleryVideo || "",
		alt: item?.alt || `gallery ${type}`,
		width: item?.width || 0,
		height: item?.height || 0,
		placeholder: type === ASSET_TYPE.IMAGE ? item?.blurUpThumb || "empty" : "empty",
		type,
	}
}

function GalleryAsset({ slide, rect }) {
	const {
		carousel: { imageFit },
	} = useLightboxProps()
	const cover = isImageSlide(slide) && isImageFitCover(slide, imageFit)
	const { type, alt, src } = slide

	const width = !cover ? Math.round(Math.min(rect.width, (rect.height / slide.height) * slide.width)) : rect.width

	const height = !cover ? Math.round(Math.min(rect.height, (rect.width / slide.width) * slide.height)) : rect.height

	return type === ASSET_TYPE.IMAGE ? (
		<Image src={src} alt={alt} style={{ width, height }} fit={cover ? "cover" : "contain"} sizes={`${width}px`} {...slide} />
	) : (
		<Video controls muted={false} style={{ width, height }} playing={false} src={src} />
	)
}

const Gallery = ({ isOpen = false, close = () => {}, index = 0, slides = [] }) => {
	const formattedSlides = useMemo(() => slides.map((item) => formatToGalleryItem(item)), [slides])
	return (
		<Lightbox
			open={isOpen}
			close={close}
			index={index}
			slides={formattedSlides}
			render={{ slide: GalleryAsset }}
			styles={{
				root: {
					zIndex: 1000001,
				},
			}}
		/>
	)
}

export default Gallery
